// key的值必须满足/^[a-zA-Z]+$/
export const PopupPageKey = {
  DETAIL: "detail",
  POINT_HISTORY: "pointHistory",
  PROFILE: "profile",
  MOBILE_LOGIN: "mobileLogin",
  MOBILE_REGISTER: "mobileRegister",
  FORGET_PASSWORD: "forgetPassword",
};
